import { render, staticRenderFns } from "./RepostsMonths.vue?vue&type=template&id=3ebad355"
import script from "./RepostsMonths.vue?vue&type=script&lang=js"
export * from "./RepostsMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports